import { DialogActions, DialogContent, Grid, Stack } from "@mui/material";
import { MutationStatus } from "@tanstack/react-query";
import { Form as FormikForm, FormikProvider, useFormik } from "formik";
import { CreditCard, Save } from "lucide-react";
import { FC } from "react";
import * as yup from "yup";

import FormikTextField from "components/forms/FormikTextField";
import MaskSocialInput from "components/forms/FormikTextField/MaskSocialInput";
import FormSection from "components/forms/FormSection";
import UltimateButton from "components/UltimateButton";

export type AddSocialNumberFormValues = {
  social: string;
};

interface IAddSocialNumberForm {
  handleSubmit: (values: AddSocialNumberFormValues) => void;
  handleClose: () => void;
  initialValues?: AddSocialNumberFormValues;
  submitStatus?: MutationStatus;
}

const AddSocialNumberForm: FC<IAddSocialNumberForm> = ({
  handleClose,
  handleSubmit,
  initialValues = {
    social: "",
  },
  submitStatus,
}) => {
  const schema = yup.object({
    social: yup.string().required().nullable(),
  });

  const formik = useFormik({
    // enableReinitialize: true,
    initialValues,
    validationSchema: schema,
    onSubmit: handleSubmit,
  });

  return (
    <FormikProvider value={formik}>
      <FormikForm>
        <DialogContent>
          <Stack spacing={3} sx={{ mt: 2 }}>
            <FormSection
              title="Social Security Number"
              description="Add the social security number for this customer."
              Icon={CreditCard}
            >
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormikTextField
                    name="social"
                    label="Social Number"
                    InputProps={{
                      inputComponent: MaskSocialInput as any,
                    }}
                  />
                </Grid>
              </Grid>
            </FormSection>
          </Stack>
        </DialogContent>
        <DialogActions>
          <UltimateButton
            type="submit"
            text="Save & Refetch"
            Icon={
              Save as React.ComponentType<{
                size?: number;
                className?: string;
                style?: React.CSSProperties;
              }>
            }
            loading={submitStatus === "loading"}
          />
        </DialogActions>
      </FormikForm>
    </FormikProvider>
  );
};

export default AddSocialNumberForm;
